import { createContext, useContext, useState } from "react";

export const CURRENCIES = {
  USD: { symbol: "$", rate: 1, name: "US Dollar" },
  AED: { symbol: "AED", rate: 3.67, name: "UAE Dirham" },
  SAR: { symbol: "SAR", rate: 3.75, name: "Saudi Riyal" },
  NGN: { symbol: "₦", rate: 1580, name: "Nigerian Naira" },
  KES: { symbol: "KSh", rate: 130, name: "Kenyan Shilling" },
  GHS: { symbol: "GH₵", rate: 14.5, name: "Ghanaian Cedi" },
  ZAR: { symbol: "R", rate: 18.5, name: "South African Rand" },
  EUR: { symbol: "€", rate: 0.92, name: "Euro" },
  GBP: { symbol: "£", rate: 0.79, name: "British Pound" },
};

const Ctx = createContext({ currency: "USD", setCurrency: () => {}, format: () => "" });

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrencyState] = useState(() => localStorage.getItem("dv_cur") || "USD");
  const setCurrency = (c) => {
    setCurrencyState(c);
    localStorage.setItem("dv_cur", c);
  };
  const format = (usd, opts = {}) => {
    const c = CURRENCIES[currency];
    const value = Number(usd) * c.rate;
    const compact = opts.compact ?? true;
    const formatted = compact && value >= 1000
      ? new Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 1 }).format(value)
      : new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(value);
    return `${c.symbol}${c.symbol.length > 1 ? " " : ""}${formatted}`;
  };
  return <Ctx.Provider value={{ currency, setCurrency, format }}>{children}</Ctx.Provider>;
};

export const useCurrency = () => useContext(Ctx);
